import React, { useEffect, useRef } from 'react'
import * as Plot from '@observablehq/plot'
import { PlotOptions } from '@observablehq/plot'

type Props = {
  data: { name: string; value: number }[]
  options?: PlotOptions
  tickFormat?: (value: string) => string
  labelsFontSize?: string
}

export default function HorizontalPlot({ data, options, tickFormat, labelsFontSize }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (data === undefined) return
    const plot = Plot.plot({
      marginLeft: 100,
      x: { axis: null },
      y: { label: null },
      marks: [
        Plot.axisY({ label: null, fontSize: labelsFontSize ?? '0.8rem', tickFormat }),
        Plot.barX(data, {
          x: 'value',
          y: 'name',
          fill: 'var(--green-50)',
        }),

        Plot.text(data, {
          text: (d) => (d.value > 0 ? `${d.value}` : ''),
          y: 'name',
          x: 'value',
          textAnchor: 'end',
          dx: -4,
          fill: 'black',
          fontSize: labelsFontSize,
        }),
      ],
      ...options,
    })
    if (containerRef?.current) {
      containerRef.current.append(plot)
    }

    return () => plot.remove()
  }, [data])

  return <div ref={containerRef} />
}
